// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2120":"c6c204dc","6073":"31cd5a54"}[chunkId] + ".chunk.css";
};